var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPbfRegisteredToAnotherPbfPayeeWithinTheSameReportingGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7,
    rx: 7.5,
    ry: 7,
    fill: "#FF2800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.97 11.162c-2.376 0-4.288-1.737-4.288-4.325 0-2.587 1.912-4.312 4.287-4.312 1.475 0 2.5.65 3.238 1.563l-.825.512c-.525-.675-1.413-1.15-2.413-1.15-1.825 0-3.212 1.4-3.212 3.388 0 1.974 1.387 3.4 3.212 3.4 1 0 1.825-.488 2.238-.9v-1.7H7.344v-.925h3.9v3.012c-.775.863-1.912 1.438-3.275 1.438z",
    fill: "#fff"
  })));
}
export default SvgPbfRegisteredToAnotherPbfPayeeWithinTheSameReportingGroup;